import { render, staticRenderFns } from "./email_participants_warning.vue?vue&type=template&id=59ef2f4d"
import script from "./email_participants_warning.vue?vue&type=script&lang=js"
export * from "./email_participants_warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports